import { apolloClient } from "@services"

const authService = {
  clearToken: () => window.localStorage.removeItem("adminToken"),
  clearApolloCache: () => apolloClient.clearStore(),
  getToken: () => window.localStorage.getItem("adminToken"),

  isAuthenticated: () => window.localStorage.getItem("adminToken") !== null,

  login: token => authService.setToken(token),

  logout: (redirect = "/") => {
    authService.clearToken()
    authService.clearApolloCache()
    window.location.replace(redirect)
  },

  setToken: token => window.localStorage.setItem("adminToken", token),
}

export default authService
